// frontend/src/UserContext.js

import React, { createContext, useState, useEffect } from 'react';
import apiClient from './apiClient';

export const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Hämtar användaren från backend, om en token finns
  const fetchUser = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const response = await apiClient.get('/auth/user');
      setUser(response.data);
    } catch (error) {
      console.error('Fel vid hämtning av användare:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Kör fetchUser en gång när appen startar
    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, loading, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
}
